import {
  BlissfulIcon,
  CbdIcon,
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  GummyIcon,
  HybridIcon,
  IndicaIcon,
  LightningIcon,
  MerchIcon,
  NotHighIcon,
  PainFreeIcon,
  PencilIcon,
  PizzaIcon,
  PrerollIcon,
  RelaxedIcon,
  SativaIcon,
  SleepIcon,
  TagIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { ReactElement } from 'react';

export const FeelingIconMap: Record<string, ReactElement> = {
  Blissful: <BlissfulIcon />,
  cbd: <CbdIcon />,
  Creative: <PencilIcon />,
  edible: <GummyIcon />,
  Energetic: <LightningIcon />,
  extract: <ExtractIcon />,
  flower: <FlowerIcon />,
  gear: <GearIcon />,
  Hungry: <PizzaIcon />,
  hybrid: <HybridIcon />,
  indica: <IndicaIcon />,
  merch: <MerchIcon />,
  'Not high': <NotHighIcon />,
  'Pain free': <PainFreeIcon />,
  'pre-roll': <PrerollIcon />,
  Relaxed: <RelaxedIcon />,
  Relieved: <PainFreeIcon />,
  sale: <TagIcon />,
  sativa: <SativaIcon />,
  Sleepy: <SleepIcon />,
  tincture: <TinctureIcon />,
  topical: <TopicalIcon />,
  vape: <VapeIcon />,
};
